import { AxiosError } from "axios";

type ShouldRetryFunction = (failureCount: number, error: AxiosError) => boolean;

export const DO_NOT_RETRY_ON_404: ShouldRetryFunction = (
  failureCount,
  error,
) => {
  return error.response?.status !== 404 && failureCount < 3;
};
